import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeActionsService {
  public themeId: string = '';
  public hasPhraseTriggered: Map<string, boolean> = new Map<string, boolean>();

  constructor() {}

  public setThemeId(themeId: string) {
    this.themeId = themeId;
  }

  public triggerThemePhraseActions(callback: Function, phraseId: string) {
    callback(phraseId);
  }

  public triggerThemeWelcomeActions(callback: Function) {
    callback();
  }

  public triggerConversationStartActions(callback: Function) {
    callback();
  }

  public setPhraseActionsTriggered(phrase: string, triggered: boolean = true) {
    this.hasPhraseTriggered.set(phrase, triggered);
  }

  public hasPhraseActionsTriggered(phrase: string): boolean {
    return this.hasPhraseTriggered.get(phrase) ? true : false;
  }

  public resetActionsState() {
    this.hasPhraseTriggered = new Map<string, boolean>();
  }
}
